"use strict";
// User utility functions for privacy and username generation
Object.defineProperty(exports, "__esModule", { value: true });
exports.generatePrivacyFriendlyUserData = exports.getInitials = exports.isRandomUsername = exports.generateUsernameFromEmail = exports.generateDisplayNameFromEmail = exports.generateRandomUsername = void 0;
// Adjectives for random username generation
const adjectives = [
    'Swift', 'Brave', 'Clever', 'Bright', 'Silent', 'Noble', 'Wise', 'Calm',
    'Bold', 'Quick', 'Sharp', 'Keen', 'Cool', 'Warm', 'Fresh', 'Clear',
    'Strong', 'Gentle', 'Pure', 'Smooth', 'Lucky', 'Happy', 'Grand', 'Elite',
    'Prime', 'Royal', 'Epic', 'Cosmic', 'Magic', 'Ocean', 'Storm', 'Frost',
    'Fire', 'Star', 'Moon', 'Sun', 'Wind', 'Rain', 'Snow', 'Wild',
    'Free', 'Dark', 'Light', 'Deep', 'High', 'Far', 'Near', 'True',
    'Rare', 'Rich', 'Poor', 'Old', 'New', 'Fast', 'Slow', 'Hot',
    'Cold', 'Big', 'Small', 'Tall', 'Short', 'Wide', 'Thin', 'Fat'
];
// Nouns related to movies, entertainment, and general terms
const nouns = [
    'Watcher', 'Viewer', 'Critic', 'Fan', 'Lover', 'Seeker', 'Hunter', 'Explorer',
    'Dreamer', 'Thinker', 'Creator', 'Artist', 'Writer', 'Reader', 'Player', 'Master',
    'Hero', 'Legend', 'Champion', 'Guardian', 'Warrior', 'Knight', 'Sage', 'Scholar',
    'Pioneer', 'Voyager', 'Wanderer', 'Nomad', 'Rider', 'Runner', 'Climber', 'Jumper',
    'Tiger', 'Lion', 'Eagle', 'Wolf', 'Bear', 'Fox', 'Owl', 'Hawk',
    'Ocean', 'River', 'Mountain', 'Valley', 'Forest', 'Desert', 'Island', 'Storm',
    'Thunder', 'Lightning', 'Rainbow', 'Sunset', 'Dawn', 'Twilight', 'Shadow', 'Spark',
    'Flame', 'Ember', 'Frost', 'Crystal', 'Diamond', 'Pearl', 'Ruby', 'Emerald',
    'Cinema', 'Screen', 'Reel', 'Frame', 'Scene', 'Story', 'Tale', 'Epic',
    'Quest', 'Journey', 'Adventure', 'Mystery', 'Drama', 'Comedy', 'Action', 'Thriller'
];
/**
 * Generates a random username with the format "AdjectiveNoun###"
 * Examples: "SwiftWatcher42", "BraveExplorer127", "CleverCritic88"
 */
const generateRandomUsername = () => {
    const adjective = adjectives[Math.floor(Math.random() * adjectives.length)];
    const noun = nouns[Math.floor(Math.random() * nouns.length)];
    const number = Math.floor(Math.random() * 900) + 100; // 3-digit number (100-999)
    return `${adjective}${noun}${number}`;
};
exports.generateRandomUsername = generateRandomUsername;
/**
 * Generates a display name from email for fallback (non-privacy mode)
 * Converts email local part to a more readable format
 */
const generateDisplayNameFromEmail = (email) => {
    if (!email)
        return 'User';
    const localPart = email.split('@')[0];
    // Remove common separators and numbers
    const cleaned = localPart
        .replace(/[._-]/g, ' ')
        .replace(/\d+/g, '')
        .trim();
    // Capitalize each word
    return cleaned
        .split(' ')
        .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
        .join(' ') || 'User';
};
exports.generateDisplayNameFromEmail = generateDisplayNameFromEmail;
/**
 * Generates a username from email (non-privacy mode)
 * Format: @emailprefix
 */
const generateUsernameFromEmail = (email) => {
    if (!email)
        return '@user';
    const localPart = email.split('@')[0];
    return `@${localPart}`;
};
exports.generateUsernameFromEmail = generateUsernameFromEmail;
/**
 * Checks if a username is randomly generated (privacy mode)
 */
const isRandomUsername = (username) => {
    // Check if it matches the pattern: starts with adjective, has noun, ends with 3 digits
    const pattern = /^[A-Z][a-z]+[A-Z][a-z]+\d{3}$/;
    return pattern.test(username);
};
exports.isRandomUsername = isRandomUsername;
/**
 * Gets initials from display name for avatar fallbacks
 */
const getInitials = (displayName) => {
    if (!displayName)
        return 'U';
    const words = displayName.trim().split(' ');
    if (words.length === 1) {
        return words[0].charAt(0).toUpperCase();
    }
    return (words[0].charAt(0) + words[words.length - 1].charAt(0)).toUpperCase();
};
exports.getInitials = getInitials;
/**
 * Generates privacy-friendly user data for new users
 */
const generatePrivacyFriendlyUserData = (email) => {
    const randomUsername = (0, exports.generateRandomUsername)();
    const displayName = (0, exports.generateDisplayNameFromEmail)(email);
    return {
        displayName: randomUsername,
        fallbackDisplayName: displayName,
        username: `@${randomUsername.toLowerCase()}`,
        initials: (0, exports.getInitials)(randomUsername),
        isPrivacyMode: true
    };
};
exports.generatePrivacyFriendlyUserData = generatePrivacyFriendlyUserData;
